export default "__VITE_PUBLIC_ASSET__2bd0d7b7__"